import {buildStateEvent, GenericStateEvent} from '../../../../common-redux'
import { closeAndLengthPTask } from '../../Model'

export interface closeAndLengthPTaskStateEvent<T> extends GenericStateEvent<T> {}

export const GetCloseAndLengthPTaskSuccessEvent = {
    type: 'GetCloseAndLengthPTaskSuccessEvent',
    build: (payload: closeAndLengthPTask) => buildStateEvent(GetCloseAndLengthPTaskSuccessEvent.type, payload)
}
